module.exports = __webpack_public_path__ + "img/banner-1-m.6f088fbf.jpg";